import script from "./ProceedQuotation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceedQuotation.vue?vue&type=script&setup=true&lang=js"

import "./ProceedQuotation.vue?vue&type=style&index=0&id=412f2b83&lang=css"

const __exports__ = script;

export default __exports__